import '../instrument';

import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app';
import { client } from './data/GraphQL/api/client';
import { Maintanance } from './pages/maintenance/maintenance';
import { SentryWrapper } from './sentry-wrapper';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <SentryWrapper>
      {import.meta.env.VITE_MAINTENANCE === 'false' ? (
        <ApolloProvider client={client}>
          <App />
        </ApolloProvider>
      ) : (
        <Maintanance />
      )}
    </SentryWrapper>
  </React.StrictMode>
);
